import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { haptic } from '@/lib/haptics';

const STAFF_MEMBERS = [
  { name: 'Boniswa', initial: 'B', color: 'from-purple-500 to-pink-500' },
  { name: 'Joy', initial: 'J', color: 'from-green-500 to-emerald-500' },
  { name: 'Bryce', initial: 'B', color: 'from-primary to-yellow-500' },
];

export function StaffBadge() {
  const { staffMember, setStaffMember } = useAuth();
  const [open, setOpen] = useState(false);

  if (!staffMember) return null;

  const current = STAFF_MEMBERS.find(s => s.name === staffMember);
  const color = current?.color || 'from-gray-500 to-gray-600';

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 active:scale-95 transition-transform"
      >
        <span className="text-xs font-medium text-gray-300">
          {staffMember}
        </span>
        <div className={`w-7 h-7 rounded-full bg-gradient-to-br ${color} flex items-center justify-center text-white text-xs font-bold shadow-md`}>
          {staffMember[0]}
        </div>
      </button>

      {open && (
        <>
          {/* Backdrop to close */}
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />

          {/* Dropdown */}
          <div className="absolute right-0 top-full mt-2 z-50 w-44 bg-dark border border-primary/30 rounded-xl shadow-2xl overflow-hidden">
            {STAFF_MEMBERS.map((staff) => (
              <button
                key={staff.name}
                onClick={() => {
                  haptic.medium();
                  setStaffMember(staff.name);
                  setOpen(false);
                }}
                className={`w-full flex items-center gap-2.5 px-3 py-2.5 transition-colors ${
                  staff.name === staffMember
                    ? 'bg-primary/10'
                    : 'hover:bg-dark-lighter/50 active:bg-dark-lighter'
                }`}
              >
                <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${staff.color} flex items-center justify-center text-white text-sm font-bold`}>
                  {staff.initial}
                </div>
                <span className={`text-sm font-medium ${staff.name === staffMember ? 'text-primary' : 'text-white'}`}>
                  {staff.name}
                </span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
